module.exports = __webpack_public_path__ + "img/dianhua@2x.57485f89.png";